import styled from 'styled-components';
import shadow from '../../assets/images/my_business/item_shadow.png';

const StyledContainer = styled.div`
	position: relative;
	padding: 17px 20px 20px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
`;

const StyledImageContainer = styled.div`
	position: relative;
	z-index: 2;
	width: 100px;
	height: 100px;
	margin: 27px auto;
`;

const StyledInfoRow = styled.div`
	position: relative;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledRightInfoContainer = styled.div`
	position: relative;
	z-index: 2;
	display: flex;
	align-items: center;
	gap: 6px;
`;

const StyledItemShadow = styled.div`
	position: absolute;
	top: -25px;
	left: 50%;
	transform: translateX(-50%);
	width: 270px;
	height: 270px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	z-index: 1;
	pointer-events: none;
`;

export {
	StyledContainer,
	StyledImageContainer,
	StyledInfoRow,
	StyledItemShadow,
	StyledRightInfoContainer,
};
